module.exports = __webpack_public_path__ + "img/rebooking.a0f23930.svg";